// countdown.js
document.addEventListener('DOMContentLoaded', () => {
  let totalSeconds = 7 * 60; // 7 minutos em segundos
  const minutesEl = document.getElementById('minutes');
  const secondsEl = document.getElementById('seconds');

  if (!minutesEl || !secondsEl) return; // Se o timer não estiver na página, sai

  function updateTimer() {
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    minutesEl.textContent = minutes.toString().padStart(2, '0');
    secondsEl.textContent = seconds.toString().padStart(2, '0');

    if (totalSeconds > 0) {
      totalSeconds--;
      setTimeout(updateTimer, 1000);
    }
  }

  updateTimer();
});
